<template>
  <v-card>
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="1">
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
              <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
              <div class="red--text text--darken-2 education_title_notitext">출입 안전교육</div>
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2" style="overflow:auto;height:200px;">
              모두에게 가치 있는 최고의 파트너, <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 방문을 환영합니다. <br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주의사항 및 교육 안내</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              <strong class="deep-orange--text">본 교육의 목적</strong><br>
              <span>
                {{ $store.state.CustomInfo.SiteNm }} 사내 규정 및 주의사항 등의 안전교육을 통한
              </span>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>내방객 및 협력사 인력에 대한 안전의식 고취</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                3.&nbsp;
                <div>사내 규정 교육을 통한 안전 작업 정착화</div>
              </div>
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></p>                
              <p class="ml-4 font-weight-bold body-1">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>                
              <p class="ml-4 font-weight-bold body-1">3. 사내 규정 교육을 통한 안전 작업 정착화</p>                 -->
              <!-- <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 사내 규정 및 주의사항 등의 안전교육을 통한</div>
              <p class="text-h6 font-weight-bold ml-4">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 사고 예방</p>
              <p class="text-h6 font-weight-bold ml-4">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>
              <p class="text-h6 font-weight-bold ml-4">3. 사내 규정 교육을 통한 안전 작업 정착화</p> -->
            </v-card-text>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">주의사항</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</div>
              </div>
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</p>
              <p class="text-h6 font-weight-bold ml-4">2. 진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</p> -->
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">교육 안내</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>인증 대상 : 내방객 / 관계사 / 협력사 전체</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>
                  <div class="mb-2">인증 기간 : 교육 수료일로부터 6개월</div>
                  (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
                </div>
              </div>
              <!-- <p class="mt-n8 ml-8 mb-2 ml-4 text_first_font">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="ml-4 font-weight-bold body-1">2. 인증 기간 : 교육 수료 일로부터 6개월</p>
              <p class="mt-n4 ml-8 font-weight-bold body-1">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="text-h6 font-weight-bold ml-4">
                2. 인증 기간 : 교육 수료 일로부터 6개월<br>
                (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
              </p> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">Contents</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div class="education_content flex-wrap d-flex justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">일반안전</strong>
                    <p class="mt-2 text_first_font">S.G.R(Safety Golden Rules)</p>
                    <p class="text_first_font">보행자 및 운전자 안전 수칙</p>
                    <p class="text_first_font">흡연 및 화재 예방 안전 수칙</p>
                    <p class="text_first_font">Penalty</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">공정 안전</strong>
                    <p class="mt-2 text_first_font">공정의 특징 및 안전 수칙</p>
                    <p class="text_first_font">화학물질 누출 시 대응 요령</p>
                    <p class="text_first_font">안전 보호구</p>
                    <p class="text_first_font">중량물 취급 안전</p>
                    <p class="text_first_font">안전표지</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">3.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">안전 작업 허가제</strong>
                    <p class="mt-2 text_first_font">허가 절차</p>
                    <p class="mt-2 text_first_font">공구 검수</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">4. 안전 작업 수칙</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">5. 비상 대응 절차(비상 대피 등)</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">6. 준수 서약서</strong><br>
                </div>

              </div>
              <v-card-text class="text-h5 lineHeight2 text-center iron_center_contents" style="margin-top: 80px;">
                <!-- <div v-if="$store.state.CustomInfo.SiteId != 'SKTC' && $store.state.CustomInfo.SiteId != 'SKMG14'" class="iron_center_contents" style="width:inherit; height:350px;">
                  <img src="../assets/fire_center_logo.png" style="height:300px"/>
                </div> -->
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC.svg" style="height:300px"/>
                </div> -->
                
                
                
              </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">S.G.R(Safety Golden Rules) 준수항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">반드시 지켜야 할 8대 S.G.R(Safety Golden Rules)</strong><br>
            </v-card-text>
            <v-divider></v-divider>

            
            
            <v-card-text class="education_content lineHeight2">
              <div class="iron_center_contents"><img src="../assets/SKTC_SGR.png" style="height:50%; width: 50%;"></div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2">
              <div class="d-flex red--text">
                1.&nbsp;
                <div>유해 위험물질 취급/작업 時 지정된 보호구 착용 (위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>사고 보고 기준 준수(즉시 보고/서면 보고)</div>
              </div>
              <div class="d-flex red--text">
                3.&nbsp;
                <div>작업 時 작업허가서 승인 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                4.&nbsp;
                <div>밀폐작업 時 산소농도/유해가스 측정(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                5.&nbsp;
                <div>고소지역 작업 時 추락 예방 조치 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>변경 관리 절차 준수 (변경 검토, 가동 전 점검)</div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>지정된 장소 外 금연 (라이터 휴대 금지)</div>
              </div>
              <div class="d-flex">
                8.&nbsp;
                <div>사내 운송수단 안전 수칙 준수</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>GOLDEN RULE을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                SGR위반 Penalty세부기준
                <v-spacer></v-spacer>
                <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              SGR위반 Penalty세부기준<br>
              <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
            </div>

            <table class="type09 text-center" style="margin-top: 40px;">
              <thead>
                <tr>
                  <th scope="cols">위반 차수 </th>
                  <th scope="cols">협력사 법인</th>
                  <th scope="cols">협력사 구성원, 작업자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차</td>
                  <td>작업중지 1일<br></td>
                  <td>출입금지 1개월<br></td>
                </tr>
                <tr>
                  <td>2차</td>
                  <td>작업중지 3일 + 입찰제한 6개월<br></td>
                  <td>출입금지 6개월<br></td>
                </tr>
                <tr>
                  <td>3차</td>
                  <td>등록 취소 <br></td>
                  <td>영구 출입 금지<br></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 교통</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex justify-space-between align-items-start">
                    <div>
                      <div class="d-flex">
                        1.&nbsp;
                        <div>사내 운송수단 속도제한 준수</div>
                      </div>
                      <div class="d-flex ml-5">
                        <v-icon>mdi-check</v-icon>
                        <div class="ml-2">차량/오토바이/자전거 10km/h, 지게차 10km/h</div>
                      </div>
                      <div class="d-flex">
                        2.&nbsp;
                        <div>운전자는 반드시 <strong class="red--text text--lighten-1">좌석 안전벨트 착용</strong></div>
                      </div>
                      <div class="d-flex">
                        3.&nbsp;
                        <div>규정된 탑승인원 준수 및 화물칸 탑승 금지</div>
                      </div>
                      <div class="d-flex">
                        4.&nbsp;
                        <div>교차로에서는 반드시 서행, 차량/사람의 통행 유무 확인 후 진행</div>
                      </div>
                      <div class="d-flex">
                        5.&nbsp;
                        <div>주행중인 차량 추월 금지(지게차, 구내운반차 등)</div>
                      </div>
                      <div class="d-flex">
                        6.&nbsp;
                        <div><strong class="red--text text--lighten-1">차량 정지 시, </strong>정지브레이크와 기어 등을 사용하여 <strong class="red--text text--lighten-1">확실히 제동 </strong> 실시</div>
                      </div>
                      <div class="d-flex">
                        7.&nbsp;
                        <div>정차 시, 받침목 설치 및 벽면으로 핸들을 조정한 후 주차</div>
                      </div>    
                    </div> 
                    <div style="float: right; margin-right: -150px; margin-top: 100px;">
                      <div class="iron_center_contents mt-5"><img src="../assets/under-construction.jpg" style="height:200px; border-radius: 10px;"></div>            
                    </div> 
                  </div>
                </v-card-text>
              </v-col>


              <!-- <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">운전자가</strong> 꼭 지켜야 할 사항<br>
                  <p class="mt-2 ml-4 text_first_font">1. 사내 규정 속도 준수</p>
                  <p class="ml-4 text_first_font">공장 내 (20km) 공장 외(30km)이내</p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      ※&nbsp;
                      <div>위반 시 <strong class="red--text text--lighten-1">"출입 정지"</strong> 등 규정에 따름</div>
                    </div>
                  </div>

                  <p class="iron_center_contents"><img src="../assets/traffic-light.png" style="height:80px"/></p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>주ㆍ정차 구역 外 주차금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>방지턱 우회 운행 및 앞지르기 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>방향 전환 시 방향 지시등 점등</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>차내 흡연 및 휴대전화 사용금지</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col> -->
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 금지행위</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>지정된 흡연구역 外 흡연금지(라이터 소지 금지)</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div><span class="red--text text--lighten-1">위험물저장소 및 인화성/폭발성 물질</span>을 취급 및 사용장소 주변에서 점화원을 가까이 하는 행위 금지</div>
                    
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>탑승하거나 올라설 수 있도록 설계된 것이 아닌 운반기구, 컨베이어, 이륜 및 사륜 장비, 손수레 등에 <span class="red--text text--lighten-1">탑승하거나 올라서는 행위 금지</span></div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div><span class="red--text text--lighten-1">뛰는 행위 금지</span>(화재 또는 생명위협, 훈련 등 예외)</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>위험 및 유해작업장소에 사전 승인 없이 출입/통행 금지</div>
                  </div>
                  <div class="d-flex">
                    6.&nbsp;
                    <div>의도적으로 사내의 물건이나 재산에 손해를 끼치는 행위 금지</div>
                  </div>
                  <div class="d-flex">
                    7.&nbsp;
                    <div><span class="red--text text--lighten-1">작업시 휴대전화 사용금지</span></div>
                  </div>
                  <div class="d-flex">
                    8.&nbsp;
                    <div><span class="red--text text--lighten-1">위험 및 공정지역</span> 內 2차 점화원(측정기, 무전기 등) <span class="red--text text--lighten-1">승인 후 사용 가능</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    9.&nbsp;
                    <div>사업장 內 전 지역 <span class="red--text text--lighten-1">사진촬영 금지</span>(단, 승인된 경우 제외)</div>
                  </div>
                  <div class="d-flex">
                    10.&nbsp;
                    <div>USB, PC, 노트북 및 기타 모든 저장매체, 전기기기 사용 금지</div>
                  </div>
                  <div class="d-flex">
                    11.&nbsp;
                    <div><span class="red--text text--lighten-1">도면 및 서류 등 사내 문서의 반출행위 금지</span></div>
                  </div>
                  <div class="d-flex">
                    12.&nbsp;
                    <div>공정지역 및 작업지역 內 음식물 반입 및 취식행위 금지(휴게공간 이용)</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents mt-5"><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"></div>    
              </v-col>
            </v-row>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 기타 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>사소하더라도 아래 사항은 즉시 SK트리켐㈜ 직원에게 알려주세요.</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">방문 중 발생한 <span class="red--text text--lighten-1">상해, 화학물질 흡입 및 접촉사고</span> 발생 또는 목격 시</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2"><span class="red--text text--lighten-1">화재, 폭발 및 화학물질 누출 </span>목격 시</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2"><span class="red--text text--lighten-1">시설물의 손상, 운반수단의 사고, 이상한 냄새, 소음 발생 </span>시</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>작업장 통행 시 <span class="red--text text--lighten-1">지정된 통로</span>를 이용하여 통행(우측통행 원칙)</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>허가 또는 승인이 필요한 장소에 임의로 출입 금지</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                  <div>계단 사용 시, 난간 사용</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  *&nbsp;
                  <div>비상전화 : 044-902-0253</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - MSDS 이해 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">물질안전보건자료(MSDS) 란?</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 물질안전보건자료(Material Safety Data Sheet) 란 물질에 관한 여러가지 정보를 담은 자료이다.</p>
              <p class="ml-4 text_first_font"> 물질에 관한 정보는 그 물질의 이름, 성분, 유해성, 위험성, 보관방법, 다룰 때 주의할 점, 필요한 보호구, 몸에 묻거나 먹었을 때 등의 응급조치 등 여러가지 정보가 포함된다.</p>
              <v-divider class="mb-2"></v-divider>
              <strong class="deep-orange--text">물질안전보건자료 게시 및 비치</strong><br>
              <p class="ml-4 mt-2 text_first_font">
                게시, 비치 방법 : 취급 근로자가 쉽게 보거나 접근할 수 있는 장소에 각 화학물질 별로 물질안전보건자료를 항상 게시 하거나 갖추어 둠,
                
              </p>
              <p class="ml-4 mt-2 text_first_font"><span style="margin-left: 127px;">취급 작업자가 물질안전보건자료를 쉽게 확인할 수 있는 전산장비를 갖추어야 함.</span></p>
              <p class="ml-4 text_first_font"> 게시 장소: 대상화학물질 취급작업 공정 내, 안전사고 또는 직업병 발생 우려가 있는 장소, 사업장 내 근로자가 가장 보기 쉬운 장소 등</p>
            </v-card-text>

          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"></div>감지기가 작동하거나
              </div>

            </div>
            <div class="iron_center_contents ml-4 mt-5 text_first_font">
              <div class="iron_center_contents ml-4 mt-5 text_first_font">
                <img src="../assets/SKTC_E.svg" style="height:300px">
              </div>
              
              
              
            </div>
            <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                  Chemical 누출 사고 발생 시 긴급전화(044-902-0253)로 신고한다.
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 관리감독자 지시에 따라 의료기관으로 후송</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  Fume 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출되어진 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전모, 안전화, 보안경</strong><strong>은 기본 착용 사항입니다.</strong>
            </v-card-text>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">작업 장소</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>  -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>검전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>공통사항</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>【보호구】 작업장소 및 공정지역 출입시 <strong class="red--text text--lighten-1">안전모, 보안경, 안전화</strong> 착용 필수 
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="ml-5">※ 기타 구역별 보호구가 지정된 장소는 해당 보호구 추가 착용 필수</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>【복장】 단정한 복장</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>【긴 머리인 경우】 묶어서 안전모 안으로 넣어 단정하게 정리</div>
                    </div>
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <!-- <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <!-- <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"/></div>녹십자
                </div> -->
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="text_first_font lineHeight2">
              <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
              </v-row>
              ※ 공구 검수 장소 : 해당 현장
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>현장입회자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(SHE팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 SHE팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>굴착신고 후 작업 </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 주변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소 익혀둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <div class="iron_center_contents ml-4 mt-5 text_first_font">
                <div class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC_E.svg" style="height:300px">
                </div>
                
                
                
              </div>
              <!-- <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div>
              </v-col> -->
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  방재센터로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                    <div class="text_first_font mb-2 mt-2 ml-4">
                      <div class="d-flex mb-2">
                        1.&nbsp;
                        <div>침착하게 상황을 알리고 신고한다.</div>
                      </div>
                      <div class="d-flex mb-2">
                        2.&nbsp;
                        <div>
                          환자의 상태를 확인하고 안정에 힘쓴다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        3.&nbsp;
                        <div>
                          구호대 또는 구급차 요원에게 인계한다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>사고 현장 출입 통제 & 현장보존</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        4.&nbsp;
                        <div>
                          의료기관으로 긴급 후송한다.<br>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        5.&nbsp;
                        <div>
                          사고 상황을 보고한다. (육하원칙)<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>유선(즉시), 서면(24Hr이내)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>                 
                </v-col>
                <v-col cols="12" md="7" sm="12">
                  
                  <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                    <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;">
                    <div class="iron_center_contents ml-4 mt-5 text_first_font">
                      <img src="../assets/SKTC_E.svg" style="height:300px">
                    </div>
                    
                    
                    
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <div class="pledge_content">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
                <div class="d-flex">
                  -&nbsp;
                  <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
                </div>
              </v-card-text> 
              
              
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <strong class="deep-orange--text font-weight-black">[집결장소]</strong><br>
                <div class="d-flex">
                  -&nbsp;
                  <div>주차장 서편 펜스 앞쪽</div>
                </div>
              </v-card-text>


              <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                <!-- 왼쪽 텍스트 영역 -->
                <div style="flex: 1;">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">[집결장소 행동요령]</strong><br>
                    <div class="d-flex" style="color: black">
                      1.&nbsp;
                      <div>대피 인원 파악 <br>Count evaluated people</div>
                    </div>
                    <div class="d-flex" style="color: black">
                      2.&nbsp;
                      <div>현장지휘소에 대피인원 및 환자발생 이상 유무 보고 <br>Report to command post of situation <br>& emergency patients</div>
                    </div>
                    <div class="d-flex" style="color: black">
                      3.&nbsp;
                      <div>현장지휘소 통제에 따라 행동 <br>Follow command post's orders</div>
                    </div>
                  </v-card-text>
                  <div class="box_3 education_content pa-2 ml-3" style="font-size: 20px; font-weight: bold; color: LightGoldenRodYellow;">
                    비상전화 044-902-0253
                  </div>
                </div>
                
                <!-- 오른쪽 이미지 영역 -->
                <v-col cols="12" md="4" sd="6">
                  <div style="flex: 1; text-align: right; margin-top: -100px; margin-right: 20px;">
                    <img src="../assets/SKTC_map.svg" style="width: 100%; max-width: 858px; border-radius: 20px;">
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 중지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>

            <v-card-text class="education_content lineHeight2 text-center">
              <v-divider class="mb-2"></v-divider>
              <div class="iron_center_contents"><img src="../assets/SKTC_stop.jpg" style="height:50%; width: 50%;"></div>
            </v-card-text>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업중지 절차</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div class="pledge_content">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        1</strong><br><span style="color: black;">사고 위험 발견</span><br><span style="color: black;">작업 중지 요청</span>
                      </div>
                      <div class="ml-3">
                        "사고 위험이 있으니 작업을 중지해 주시기 바랍니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        2</strong><br><span style="color: black;">작업 중지</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 멈추고 안전한 장소로 이동<br>
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>작업을 중지하지 않은 인원의 작업을 중지시키고 안전한 장소로 이동 시킴<br>
                        <v-icon>mdi-check</v-icon>"사고 위험 우려가 있어 작업중지 통보를 받았으니 현장확인을 요청합니다."<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        3</strong><br><span style="color: black;">위험요인 제거</span><br><span style="color: black;">&작업재개</span>
                      </div>
                      <div class="ml-3 mt-3">
                        <span class="font-weight-bold">작업감독자/관리감독자</span><br>
                        <v-icon>mdi-check</v-icon>위험요인의 제거, 구호조치(필요시), 추가 피해 방지 조치<br>
                        <span class="font-weight-bold">SKTC 관리감독자(해당작업) & SHE</span><br>
                        <v-icon>mdi-check</v-icon>위험요인 제거 및 추가 피해 방지 조치, 추가 위험요인 등 확인<br>
                        <v-icon>mdi-check</v-icon>모든 위험요인 제거 후 작업재개 요청<br>
                      </div>
                    </div>
                    <div class="circle_Box2_no d-flex" style="margin: -60px 65px;"><v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon></div>
                    <div class="d-flex align-center">
                      <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">
                        4</strong><br><span style="color: black;">기록관리</span>
                      </div>
                      <div class="ml-3">
                        <span class="font-weight-bold">SKTC SHE팀</span><br>
                        <v-icon>mdi-check</v-icon>통합SHE시스템 기록 관리<br>
                      </div>
                    </div>
                  </div>
                </v-card-text> 
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">환경 안전 보건 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <strong class="deep-orange--text font-weight-black">1. SHE 방침</strong><br>
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 구축</strong><br>
                  SHE 중심 경영을 통해 구성원, 지역사회, 고객사, 협력사 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장 구축을 지속적으로 추진한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 기업 문화 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용 및 최적의 오염방지시설 도입으로 오염물질의 배출을 최소화하고 유해화학물질의 체계적인 관리와 투명한 정보공개를 통해 사업장과 지역사회의 환경을 보호한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영을 통한 신뢰 확보</strong><br>
                  안전/보건/환경 관련 법규 및 이해관계자의 요구사항을 철저히 준수하고, 최고 수준의 SHE 경영체계를 구축하여 투명하게 공개함으로써 이해관계자의의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  전 구성원은 SHE 가치 향상을 경영의 핵심과제로 인식하고, 참여와 협의를 통해 SHE경영체계를 공고히 한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전제보(익명) </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <div class="iron_center_contents"><img src="../assets/SKTC_QR.png" style="height:50%; width: 50%;"></div>
            <!-- <v-col cols="12" md="8" sd="12">
              <v-card-text class="education_content lineHeight2 pa-0">
                <strong class="deep-orange--text"></strong>
              </v-card-text>
              <table class="type11 text-center">
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">물성</td>
                    <td class="table_line_right">인화점</td>
                    <td class="table_line_right">자료 없음</td>
                    <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex">
                        <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">자연발화점</td>
                    <td class="table_line_right">자료 없음</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">비중</td>
                    <td class="table_line_right">0.997</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">끓는점</td>
                    <td class="table_line_right">19.5℃</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                    <td class="table_line_right">화학물질명</td>
                    <td class="table_line_right">관용명 및 이명</td>
                    <td class="table_line_right">CAS. No</td>
                    <td class="table_line_right">함유량</td>
                    <td>노출기준</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">HF</td>
                    <td class="table_line_right">Hydrogen Fluoride</td>
                    <td class="table_line_right">7664-39-3</td>
                    <td class="table_line_right">100%</td>
                    <td>TWA 0.5 ppm</td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="text_first_font">
                    <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                    <th scope="cols" colspan='3'>NFPA CODE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table_line_right" rowspan="4">보호구</td>
                    <td class="table_line_right">개인보호구</td>
                    <td class="table_line_right" colspan="2">방독 마스크</td>
                    <td rowspan="4" colspan="3">
                      <div class="d-flex align-center justify-center">
                        <img src="../assets/graph-text_1.svg" style="height:100px; border-radius: 10px;margin-right : 15px;"/>
                        <img src="../assets/graph_1.svg" style="height:120px;"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">눈 보호</td>
                    <td class="table_line_right" colspan="2">보안경, 고글</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">손 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                  </tr>
                  <tr>
                    <td class="table_line_right">신체 보호</td>
                    <td class="table_line_right" colspan="2">내화학성 보호의</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" colspan="2">공학적 관리</td>
                    <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                    <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                  </tr>
                  <tr>
                    <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                    <td class="table_line_right">취급</td>
                    <td class="table_line_right" colspan="2">물과 접촉을 피할 것</td>
                    <td rowspan="2" colspan="3" class="img_area">
                      <div class="d-flex flex-wrap">
                        <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"/></div>
                        <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"/></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="table_line_right">저장</td>
                    <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" md="4" sd="12">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                  <div>피부에&nbsp;<span class="red--text text--lighten-1">심한 화상</span>을 일으킴.</div>
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 심한 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입하면 치명적임
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부, 눈, 점막, 폐 등에 손상을 일으킴
                </div>
                <div class="d-flex align-start">
                  <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>약한 상처는 바로 나타나지 않지만 수 시간 후에 통증이 생길 수 있음
                </div>
              </v-card-text>
            </v-col> -->
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn v-show="e1 == 1" @click="$emit('CloseEdu')" text width="100"><v-icon>mdi-close</v-icon>취소</v-btn>
      <v-btn v-show="e1 != 1" text width="100" @click="PreviewPage()"><v-icon>mdi-chevron-left</v-icon>뒤로</v-btn>
      <v-btn v-show="e1 != 25" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-show="e1 == 25" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
    </v-card-actions>
  </v-card>    
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    e1: 1,
    ChangableHeight : "",
  }),

  props: {
    oCustomInfo: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  computed: {
    ...mapState(["sNowYear","sNowMounth","sNowDate"]),
  },

  mounted() {
    this.$nextTick(() => {
  try {
    const element = document.getElementById("1");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  } catch (e) {
    // 오류 발생 시에도 콘솔에 아무것도 출력 안 하고 조용히 무시
  }
});

  },

  methods: {
    onResize(){
      if (window.innerWidth > 1350) {
        this.ChangableHeight = "calc(90vh - 225px)"
      } else if (window.innerWidth > 950 && window.innerWidth <= 1350) {
        this.ChangableHeight = "calc(90vh - 250px)"
      } else {
        this.ChangableHeight = String(document.getElementById('safe_4_rules_content').clientHeight) + "px"
      }
    },

    PreviewPage(){
      this.e1 -= 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })
    },

    NextPage(){
      this.e1 += 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })

      
    },
  }
};
</script>

<style scoped lang="scss">
  @import "../publishing/visit.scss";

  .box_2{
    width : inherit;    
    border-radius: 20px;    
    color: #FFEB3B;
    background-color: #F44336;
    text-align: center;    
  }
  .box_3{
    width : 350px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_4{
    width : 500px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_outlined{
    width : 300px;
    height : 200px;
    border-radius: 10px;    
    outline: solid;
    outline-color: #AAAAAA;
    outline-width: 1px;
    background-color: #f0f0f0;
    text-align: center;    
  }
  .circle_Box{    
    width : 32px;
    height : 32px;
    border-radius: 100px;    
    color : white;
    background-color: #000088;
    text-align: center;    
  }
  .circle_Box2{
    width : 170px;
    height : 170px;
    border-radius: 100px;        
    background-color: #EEEEEE;
    padding-top: 20px;
    text-align: center;    
  }
  .square_Box{
    width : 160px;
    height : 100px;
    border-radius: 10px;        
    background-color: #eb854a;
    padding-top: 10px;
    text-align: center;    
  }

  .square_Box2{
    width : 250px;
    height : 120px;
    border-radius: 10px;        
    background-color: #EEEEEE;
    padding-top: 10px;
    text-align: center;    
  }

  .circle_Box4{
    width : 190px;
    height : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3; 
  }
  .circle_Box4_longtext {
    max-width : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3;
  }
  .circle_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .circle_Box3{
    width : 160px;
    height : 160px;
    border-radius: 100px;        
    background-color: #F44336;
    padding-top: 20px;
    text-align: center;    
  }
  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type10 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type10 thead th {
    padding: 11px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type10 body th {
    width: 350px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    
  }
  table.type10 td {
    width: 500px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
  }
  
  table.type11 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type11 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type11 tbody th {
    max-width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type11 td {
    max-width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type11 td.img_area {
    max-width: 400px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }


  table.type12 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width: 100%;
    vertical-align: middle;
  }

  table.type12 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    border-bottom: 1px solid #ccc; 
    border-top: 1px solid rgb(141, 141, 141);
    border-right: 1px solid #ccc; 
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 td {
    width: 350px;
    padding: 10px;
    vertical-align: center;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  .safe_4_rules {
    position : absolute;
    top : 0px;
    left : 0px;
    width : 100%;
  }

  .table_line_right {
    border-right: 1px solid #ccc;
  }

  .superscript {
    vertical-align: super;
    font-size: 12px;
  }

  .pledge_content {
    overflow:auto;
    @media screen and (min-width: 1065px) {
      width: 100%;
      height:calc(90vh - 155px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 115px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }



</style>
